module.exports = __webpack_public_path__ + "img/gntech_gallery0.77b8ea37.jpg";